import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

export const ContactSupport = () => {
    return (
        <section>
            <div>
                <p style={{ display: "inline-block", width: "22rem" }}>
                    <FormattedMessage
                        id={"checkemail.didNotReceive"}
                        defaultMessage={
                            "<strong>{question}</strong> Check your spam folder."
                        }
                        values={{
                            ...DEFAULT_VALUES,
                            question: (
                                <FormattedMessage
                                    id={"checkemail.question"}
                                    defaultMessage={"Didn't receive an email?"}
                                />
                            )
                        }}
                    />
                </p>
            </div>
        </section>
    );
};
